import apiService from './api'

/**
 * Live API Service for SKINOZ
 * Handles live wins data from /api/live/ endpoint
 */

class LiveApiService {
  /**
   * Get live wins data
   * @returns {Promise<Object>} Live data with wins array and online count
   */
  async getLiveWins() {
    try {
      const response = await apiService.get('/api/live/')
      
      if (response.live) {
        return {
          wins: response.live.win || [],
          online: response.live.online || 0
        }
      }
      
      throw new Error('Invalid live data format')
    } catch (error) {
      console.error('Failed to fetch live wins:', error)
      throw error
    }
  }
}

// Create singleton instance
const liveApiService = new LiveApiService()

export default liveApiService
